import axios from "axios";
import { API_BASE_URI } from "../../../redux/ApiCall";

export const sendEmailResetLink = (email: string) => {
  return axios.post(API_BASE_URI + `/user/send-reset-link/${email}`);
};
